import * as React from "react";
import { observer } from "mobx-react";
import { Form } from "antd";
import MetadataDefinitionStore from "../stores/MetadataDefinitionStore";
import MetadataDefinitionEditForm from "./MetadataDefinitionEditForm";
import AppModal from "../../common/components/AppModal";

type Props = {
    store: MetadataDefinitionStore;
};

const MetadataDefinitionCreateEditDialog: React.FC<Props> = ({ store }) => {
    const mode = store.editDialogMode;
    const [form] = Form.useForm();
    return (
        <AppModal
            data-id-type="modal-window"
            data-id-name="edit-metadata-definition"
            className="alpha-modal"
            title={`${mode === "create" ? "Create new" : "Edit"} metadata definition`}
            open={store.editDefinitionDialogVisible}
            closable={false}
            centered
            cancelButtonTitle="Cancel"
            onCancelClick={() => {
                store.setNewDefinitionDialogVisible(false);
                form.resetFields();
            }}
            cancelButtonProps={{
                "data-id": "button-edit-metadata-definition-cancel",
            }}
            submitButtonTitle="Save"
            submitButtonProps={{
                "data-id": "button-edit-metadata-definition-save",
                className: "dark",
                form: "edit-metadata-definition-form",
            }}
        >
            <MetadataDefinitionEditForm store={store} form={form} />
        </AppModal>
    );
};

export default observer(MetadataDefinitionCreateEditDialog);
